function bytesToSpeed(fileSizeInBytes) {
    var i = -1;
    var byteUnits = ["kbps", "Mbps", "Gbps", "Tbps", "Pbps", "Ebps", "Zbps", "Ybps"];

    if (fileSizeInBytes < 1000) return fileSizeInBytes + "bps";

    while (fileSizeInBytes >= 1000) {
        fileSizeInBytes = fileSizeInBytes / 1000;
        i++;
    }

    return fileSizeInBytes.toFixed(2) + byteUnits[i];
}

export { bytesToSpeed };



// WEBPACK FOOTER //
// ./src/libs/numeralextend.js